// D:\directiveai-react\frontend\src\components\AGTPromo\TestimonialCard.js - Modificado

import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Quote } from 'lucide-react';

const CardContainer = styled(Box)(({ theme, gradientcolors }) => ({
  width: 320,
  height: 140,
  borderRadius: 16,
  padding: theme.spacing(2.5),
  background: gradientcolors ? 
    `linear-gradient(to bottom right, ${gradientcolors})` : 
    (theme.palette.mode === 'dark' ? '#1c1c1e' : '#f2f2f7'),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
  },
  [theme.breakpoints.down('sm')]: {
    width: 280,
    height: 130,
    padding: theme.spacing(2),
  },
}));

const QuoteIcon = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  '& svg': {
    width: 24,
    height: 24,
    color: 'rgba(255, 255, 255, 0.8)',
  },
}));

const TestimonialText = styled(Typography)(({ theme }) => ({
  fontSize: '0.95rem',
  fontWeight: 500,
  lineHeight: 1.5,
  color: '#ffffff',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.85rem',
    WebkitLineClamp: 2,
  },
}));

const TestimonialCard = ({ text, gradientColors }) => {
  return (
    <CardContainer gradientcolors={gradientColors}>
      <QuoteIcon>
        <Quote />
      </QuoteIcon>
      <TestimonialText>
        {text}
      </TestimonialText>
      {/* Eliminamos el autor/título de sección */}
    </CardContainer>
  );
};

TestimonialCard.propTypes = {
  text: PropTypes.string.isRequired,
  gradientColors: PropTypes.string
};

export default TestimonialCard;